function navLinkClassNameFn({ isActive }) {
  return [
    'nav__item__link',
    isActive ? 'nav__item__link--active' : '',
  ].join(' ')
}

export {
  navLinkClassNameFn,
}
